import React, {Component} from 'react'
import {Icon}             from 'antd'
import prettysize         from '../../utils'
import {BarChart, ResponsiveContainer, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip} from 'recharts'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import logoWasabi  from '../../assets/logo/wasabi.png'
import logoS3      from '../../assets/logo/logo-amazon.png'
import logoAzure   from '../../assets/logo/logo-microsoft-azure.png'
import logoGoogle  from '../../assets/logo/logo-google-cloud.png'

import './styles.scss'

class CloudCompare extends Component {

  constructor(props) {
    super(props)

    this.cloud = (props.items.filter(c=> c.id === props.match.params.id)||[])[0]

    this.price = {
      aws:{
        '50'  : 0.023,
        '450' : 0.022,
        '500' : 0.021
      },

      azure:{
        '50'  : 0.0184,
        '450' : 0.0177,
        '500' : 0.017
      },

      wasabi : 0.0049,

      google : 0.026
    }

    this.egress = {
      wasabi : 0,
      azure  : 0.087,
      aws    : 0.15,
      google : 0.12
    }

    this.units = {
      'GB' : 1,
      'TB' : 1024,
      'PB' : 1048576
    }

    this.state = {
      loading : false,

      storage_cost : [0, 0, 0, 0],
      additional_cost : [0, 0, 0, 0],

      cost_percent : {
        wasabi : 0,
        azure  : 0,
        aws    : 0,
        google : 0
      },

      size : (((this.cloud||{}).total_bytes_used||0)/(1024*1024*1024))||1,
      unit : 'GB'
    }
  }

  componentDidMount(){
    this.refresh(this.state.size)
  }

  refresh = size => {
    let wasabi_cost =  this.calculate_wasabi_cost(size)
    let aws_cost    =  this.calculate_aws_cost(size)
    let azure_cost  =  this.calculate_azure_cost(size)
    let google_cost =  this.calculate_google_cost(size)

    let storage_cost = [
      parseFloat(wasabi_cost),
      parseFloat(wasabi_cost),
      parseFloat(wasabi_cost),
      parseFloat(wasabi_cost)
    ]

    let additional_cost = [
      0,
      parseFloat((aws_cost    - wasabi_cost).toFixed(2)),
      parseFloat((azure_cost  - wasabi_cost).toFixed(2)),
      parseFloat((google_cost - wasabi_cost).toFixed(2))
    ]

    let cost_percent = {
      wasabi : 0,
      azure  : parseFloat(((100 * azure_cost)/wasabi_cost).toFixed(0)),
      aws    : parseFloat(((100 * aws_cost)/wasabi_cost).toFixed(0)),
      google : parseFloat(((100 * google_cost)/wasabi_cost).toFixed(0))
    }

    this.setState({storage_cost, additional_cost, cost_percent})
  }

  calculate_wasabi_cost = size =>{
    size = size * (this.units[this.state.unit]||1)
    return ((size * this.price.wasabi)||0).toFixed(4)
  }

  calculate_azure_cost = size =>{
    size = size * (this.units[this.state.unit]||1)
    let cost = 0

    cost += (size > 50 ? 50:size) * this.price.azure["50"]

    if(size > 450){
      cost += (size - 450) * this.price.azure["450"]
    }
    if(size > 500){
      cost += (size - 500) * this.price.azure["500"]
    }
    return (cost||0).toFixed(4)
  }

  calculate_aws_cost = size =>{
    size = size * (this.units[this.state.unit]||1)

    let cost = 0

    cost += (size > 50 ? 50:size) * this.price.aws["50"]

    if(size > 450){
      cost += (size - 450) * this.price.aws["450"]
    }
    if(size > 500){
      cost += (size - 500) * this.price.aws["500"]
    }
    return (cost||0).toFixed(4)
  }

  calculate_google_cost = size =>{
    size = size * (this.units[this.state.unit]||1)
    return ((size * this.price.google)||0).toFixed(4)
  }

  on_change= e => {
    let { name, value } = e.target
    if(name === 'size'){
      value = (parseFloat(value||1)||1).toFixed(0)
    }
    this.setState({[name]: value}, ()=> this.refresh(this.state.size))
  }

  format = cost => {
    console.log()
    return (cost||'0').replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }

  render() {
    const {storage_cost, additional_cost, size, unit, cost_percent} = this.state
    const {aws, azure, wasabi, google} = this.price

    const data = [
      {name: 'Wasabi', color:'#15E8BA', cost: storage_cost[0], additional: additional_cost[0]},
      {name: 'Azure',  color:'#035BDA', cost: storage_cost[1], additional: additional_cost[1]},
      {name: 'S3',     color:'#FFC900', cost: storage_cost[2], additional: additional_cost[2]},
      {name: 'Google', color:'#F37A1A', cost: storage_cost[3], additional: additional_cost[3]}
      ]

    return (
      <div className='cloud-compare'>
        <div>
          {/*<div className={'cloud-header'}>
            <div className={'size-input'} >
              <SizeInput size={size} unit={unit} on_change={this.on_change} />
            </div>
            <h2>Compare prices between cloud storage providers</h2>
          </div>*/}

          <div className={'body'}>
            <table className="price-table" >
              <tbody>

              <tr className={'row'}>
                <th><span className="pricing-header" >Provider</span></th>
                <th>
                  <Icon type="hdd"/>
                  <br/>
                  <span className="pricing-header">Storage</span>
                  <span className="pricing-header-description">($/GB/Month)</span>
                  <br/>
                </th>

                <th>
                  <Icon type="cloud" />
                  <br/>
                  <span className="pricing-header">Total Cost</span>
                  <span className="pricing-header-description">($/{prettysize((size * (this.units[unit]||1)) * 1024 * 1024 * 1024)})</span>
                  <br/>
                </th>
              </tr>

              <tr>
                <td>
                  <img src={logoWasabi} className="img-responsive comparison-logo" alt="Wasabi"/>
                </td>

                <td>
                  ${wasabi}
                </td>

                <td>
                  ${this.format((storage_cost[0]||0).toFixed(4))}
                </td>
              </tr>

              <tr>
                <td >
                  <img src={logoAzure} className="img-responsive comparison-logo" alt="Microsoft Azure Cloud Storage"/>
                </td>

                <td>
                  ${azure["500"]}+
                  <br/>
                  <span className="comparison-blue">
                    +{cost_percent.azure}%
                  </span>
                </td>

                <td>
                  ${this.format((storage_cost[1] + additional_cost[1]||0).toFixed(4))}
                  <br/>
                  <span className="comparison-blue">+egress</span>
                </td>
              </tr>

              <tr>
                <td >
                  <img src={logoS3} className="img-responsive comparison-logo" alt="Amazon S3 Storage"/>
                </td>

                <td >
                  ${aws["500"]}+
                  <br/>
                  <span className="comparison-blue">
                    +{cost_percent.aws}%
                  </span>
                </td>

                <td>
                  ${this.format(((storage_cost[2] + additional_cost[2]||0).toFixed(4)))}
                  <br/>
                  <span className="comparison-blue">+egress</span>
                </td>
              </tr>

              <tr>
                <td>
                  <img src={logoGoogle} className="img-responsive comparison-logo" alt="Google Cloud Storage"/>
                </td>

                <td>
                  ${google}
                  <br/>
                  <span className="comparison-blue">
                    +{cost_percent.google}%
                  </span>
                </td>

                <td>
                  ${this.format((storage_cost[3] + additional_cost[3]||0).toFixed(4))}
                  <br/>
                  <span className="comparison-blue">+egress</span>
                </td>
              </tr>

              <tr>
                <td/>
                <td/>
                <td/>
              </tr>

              </tbody>
            </table>

            <ResponsiveContainer>
              <BarChart
                width={600}
                height={450}
                margin={{ right: 30}}
                className={'bar-chart'}
                data={data}>
                <XAxis dataKey="name"/>
                <YAxis type="number" name='Cost' tickFormatter={value=> '$' + this.format(value.toString())}/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Tooltip/>

                <Bar dataKey="cost" stackId="a" fill="#8884d8" >
                  {data.map(entry => <Cell fill={entry.color} />)}
                </Bar>

                <Bar dataKey="additional" stackId="a" fill="#8884d8" >
                  {data.map(entry => <Cell fill={entry.color} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

const SizeInput = ({ size, unit, on_change }) => (
  <div>
    <input type='number' value={size} className='input' name='size' onChange={on_change}/>
    <select className='input' value={unit} name='unit' onChange={on_change}>
      <option value='GB'>GB</option>
      <option value='TB'>TB</option>
      <option value='PB'>PB</option>
    </select>
  </div>
)

export default withRouter(connect(({ cloudAccounts }) => {
    return {...cloudAccounts}
  },
(dispatch) => bindActionCreators({}, dispatch))(CloudCompare))
